import { render, staticRenderFns } from "./distributed-columns.vue?vue&type=template&id=573f92eb&scoped=true"
import script from "./distributed-columns.vue?vue&type=script&lang=js"
export * from "./distributed-columns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573f92eb",
  null
  
)

export default component.exports